import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { ErrorToast, SuccessToast } from "@/components/toast/Toasts";
import {
  IPriceRange,
  IInsertPriceRangePayload,
  IUpdatePriceRangePayload,
  IActiveInactivePriceRangePayload,
  IFindAllPriceRangePayload,
} from "./priceRangeModel";

export const findAllPriceRange = createAsyncThunk(
  "PriceRange/FindAllPriceRange",
  async (payload?: IFindAllPriceRangePayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/ProductPriceRange/FindAllProductPriceRange`,
        {
          ItemQty: payload?.ItemQty ?? null,
        },
      );
      return (response.data?.Data || []).map((item: any) => ({
        ...item,
        IsActive: item.IsActive || false,
      }));
    } catch (error: any) {
      console.error("Error Fetching Price Range:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findAllActivePriceRange = createAsyncThunk(
  "PriceRange/FindAllActivePriceRange",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/ProductPriceRange/FindAllActiveProductPriceRange`,
      );
      return (response.data?.Data || []) as IPriceRange[];
    } catch (error: any) {
      console.error("Error Fetching Active Price Range:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertPriceRange = createAsyncThunk(
  "PriceRange/InsertPriceRange",
  async (priceRangeData: IInsertPriceRangePayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/ProductPriceRange/InsertProductPriceRange`,
        priceRangeData,
      );
      SuccessToast(response.data?.Details || "Price Range added successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Price Range:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updatePriceRange = createAsyncThunk(
  "PriceRange/UpdatePriceRange",
  async (priceRangeData: IUpdatePriceRangePayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/ProductPriceRange/UpdateProductPriceRange`,
        priceRangeData,
      );
      SuccessToast(response.data?.Details || "Price Range updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Price Range:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findByIDPriceRange = createAsyncThunk(
  "PriceRange/FindByIDPriceRange",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/ProductPriceRange/FindByIDProductPriceRange`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        ItemQty: result?.ItemQty,
        ItemPercentage: result?.ItemPercentage,
        IsActive: result?.IsActive || false,
      } as IPriceRange;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Price Range:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactivePriceRange = createAsyncThunk(
  "PriceRange/ActiveInActivePriceRange",
  async (payload: IActiveInactivePriceRangePayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/ProductPriceRange/ActiveInActiveProductPriceRange`,
        payload,
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Price Range:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deletePriceRange = createAsyncThunk(
  "PriceRange/DeletePriceRange",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/ProductPriceRange/DeleteProductPriceRange`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Price Range deleted successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Price Range:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
